// Strips characters commonly used as separators in phone numbers, including a
// single leading `+`, so international-format numbers (e.g. "+1 415 555 1212")
// clean down to digits-only.
export function cleanPhone(phone: string): string {
  return phone.replace(/^\+/, '').replace(/[\s\-()]+/g, '')
}

export function isValidPhoneNumber(phone: string): boolean {
  return /^\d{10,15}$/.test(cleanPhone(phone))
}
